module.exports = __webpack_public_path__ + "static/img/img11.6d93ecac.png";